/**
 * Scroll utilities for smooth page navigation
 */

/**
 * Scrolls to the top of the page smoothly
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 */
export const scrollToTop = (smooth = true) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smooth ? 'smooth' : 'instant'
    });
  };
  
  /**
   * Scrolls to a specific element by ID
   * @param {string} elementId - The ID of the element to scroll to
   * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
   * @param {number} offset - Offset from the top in pixels (default: 0)
   */
  export const scrollToElement = (elementId, smooth = true, offset = 0) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
  
      window.scrollTo({
        top: offsetPosition,
        left: 0,
        behavior: smooth ? 'smooth' : 'instant'
      });
    }
  };
  
  /**
   * Custom hook to automatically scroll to top on route changes
   */
  export const useScrollToTop = () => {
    return () => {
      setTimeout(() => scrollToTop(), 0);
    };
  };